import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  NavBar,
  Button,
  Tag,
  Toast,
  SpinLoading,
  Empty,
  FloatingBubble,
} from 'antd-mobile';
import { AddOutline, MessageOutline } from 'antd-mobile-icons';
import { zavhozApi } from '../api';
import { ZAVHOZ_STATUSES } from './zavhozMeta';
import dayjs from 'dayjs';

function ZavhozPage() {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadRequests = useCallback(async () => {
    setLoading(true);
    try {
      const res = await zavhozApi.myList();
      setRequests(res.data || []);
    } catch (err) {
      Toast.show({ icon: 'fail', content: 'Ошибка загрузки заявок' });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRequests();
  }, [loadRequests]);

  return (
    <div style={{ padding: '0 12px 20px' }}>
      <NavBar
        onBack={() => navigate(-1)}
        style={{ background: '#1890ff', color: '#fff', margin: '0 -12px' }}
      >
        Завхоз
      </NavBar>

      <div style={{ padding: '12px 0' }}>
        <Button
          block
          color="primary"
          onClick={() => navigate('/zavhoz/new')}
          style={{ borderRadius: 12, marginBottom: 12 }}
        >
          <AddOutline style={{ marginRight: 4 }} />
          Новая заявка
        </Button>
        <Button
          block
          color="primary"
          fill="outline"
          onClick={loadRequests}
          loading={loading}
          style={{ borderRadius: 12 }}
        >
          Обновить список
        </Button>
      </div>

      {loading && requests.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <SpinLoading />
        </div>
      ) : requests.length === 0 ? (
        <Empty description="У вас пока нет заявок" style={{ paddingTop: 40 }} />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {requests.map((req) => {
            const status = ZAVHOZ_STATUSES[req.status] || { label: req.status, color: 'default' };
            return (
              <div
                key={req.id}
                onClick={() => navigate(`/zavhoz/${req.id}`)}
                style={{
                  padding: 14,
                  borderRadius: 12,
                  background: '#fff',
                  border: '1px solid #f0f0f0',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
                  cursor: 'pointer',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                  <div style={{ fontSize: 15, color: '#262626', fontWeight: 500, lineHeight: 1.3, flex: 1, minWidth: 0 }}>
                    {req.description}
                  </div>
                  <Tag color={status.color} style={{ flexShrink: 0 }}>
                    {status.label}
                  </Tag>
                </div>
                {req.category && (
                  <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 6 }}>
                    {req.category}
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                  <div style={{ fontSize: 12, color: '#bfbfbf' }}>
                    {req.created_at ? dayjs(req.created_at).format('DD.MM.YYYY HH:mm') : ''}
                  </div>
                  {req.comments_count > 0 && (
                    <div style={{ fontSize: 12, color: '#8c8c8c', display: 'flex', alignItems: 'center', gap: 4 }}>
                      <MessageOutline />
                      {req.comments_count}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <FloatingBubble
        style={{
          '--initial-position-bottom': '80px',
          '--initial-position-right': '16px',
          '--edge-distance': '16px',
        }}
        onClick={() => navigate('/zavhoz/new')}
      >
        <AddOutline fontSize={28} />
      </FloatingBubble>
    </div>
  );
}

export default ZavhozPage;
